import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { lista_precio_detalle } from 'src/app/shared/object/lista_precio_detalle.model';
import { producto } from 'src/app/shared/object/producto.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { RutService } from "src/app/shared/services/rut.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { ProductoModalPrecioCostoComponent } from "../modal-precio-costo/modal-precio-costo.component";
import { ListaPrecioDetalleService } from "src/app/services/lista-precio-detalle.service";
@Component({
  selector: 'app-productos-form-datos-comerciales',
  templateUrl: './form-datos-comerciales.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ProductosFormDatosComercialesComponent implements OnInit {

  // Output
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  private client: GraphQLClient = null;

  optionsFormatoProducto: Array<any> = [];

  listaListaPrecioDetalle: Array<any> = [];

  // Modales
  @ViewChild('editarComerciales', { static: true }) editarComercialesModal: ModalDirective;
  @ViewChild(ProductoModalPrecioCostoComponent, { static: true }) modalSeleccionarPrecioCosto: ProductoModalPrecioCostoComponent

  // Form && Main Data
  formDatosComerciales: FormGroup;
  rut_empresa: number;
  sucursal_codigo: number;
  codgo_modulo: number = 2;
  rut_usuario: number;
  disabledContent: boolean = false
  precio_costo: number = 0;
  producto_nombre: any
  // producto: producto

  public neto_1: number;
  public neto_2: number;
  public neto_3: number;
  public neto_4: number;
  public neto_5: number;

  public margen_1: number;
  public margen_2: number;
  public margen_3: number;
  public margen_4: number;
  public margen_5: number;

  public impuestoAdicPro: number;
  public parametro_iva: number;

  public iva1: number;
  public impAdicional1: number;
  public preciofinal1: number;

  public iva2: number;
  public impAdicional2: number;
  public preciofinal2: number;

  public iva3: number;
  public impAdicional3: number;
  public preciofinal3: number;

  public iva4: number;
  public impAdicional4: number;
  public preciofinal4: number;

  public iva5: number;
  public impAdicional5: number;
  public preciofinal5: number;

  // Utils
  private log: any

  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private toastrService: ToastService,
    private rutService: RutService,
    private clog: ConsoleService,
    private formValidatorsService: FormValidatorsService,
    private listaPrecioDetalleService: ListaPrecioDetalleService,
  ) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS-ADD/EDIT / DATOS COMERCIALES')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario())
    this.createForm()
    this.formChangesSubscriptions()

  }

  createForm() {
    this.formDatosComerciales = this.formBuilder.group({
      producto_codigo: [''],
      formato: ['', [Validators.required]],
      neto1: ['', [Validators.required, Validators.min(1)]],
      neto2: [''],
      neto3: [''],
      neto4: [''],
      neto5: [''],
      margen1: ['', [Validators.required]],
      margen2: [''],
      margen3: [''],
      margen4: [''],
      margen5: [''],
    });
  }


  formChangesSubscriptions() {
    this.formDatosComerciales.get("neto1").valueChanges.subscribe(data => {
      this.reCalcularLista1()
    });

    this.formDatosComerciales.get("neto2").valueChanges.subscribe(data => {
      this.reCalcularLista2()
    });

    this.formDatosComerciales.get("neto3").valueChanges.subscribe(data => {
      this.reCalcularLista3()
    });

    this.formDatosComerciales.get("neto4").valueChanges.subscribe(data => {
      this.reCalcularLista4()
    });

    this.formDatosComerciales.get("neto5").valueChanges.subscribe(data => {
      this.reCalcularLista5()
    });

    this.formDatosComerciales.get("formato").valueChanges.subscribe(data => {
      let producto = this.formDatosComerciales.controls["producto_codigo"].value;
      let formato = this.formDatosComerciales.controls["formato"].value;

      this.loadPrecioCosto(producto, formato)
      if (producto !== null && formato !== null) {
        this.obtenerListaPrecioxFormato(producto, formato);
        this.reCalcularLista1()
        this.reCalcularLista2()
        this.reCalcularLista3()
        this.reCalcularLista4()
        this.reCalcularLista5()
        return
      } else {
        return
      }
    });
  }

  obtenerListaPrecioxFormato(producto: number, formato: string) {
    if (producto != null && formato != '') {
      let self = this;
      this.client.query({
        query: gql`
        query($empresa_rut:Decimal, $sucursal_codigo:Decimal,
          $producto_codigo:Decimal, $formato_codigo:String){
            lista_precio_detalle{
              obtenerListaPrecio(entidad:{
                empresa_rut:$empresa_rut
                sucursal_codigo:$sucursal_codigo
                producto_codigo:$producto_codigo,
                formato_codigo:$formato_codigo
              }){
                respuesta{
                  registros{
                    lista_precio_codigo
                    empresa_rut
                    sucursal_codigo
                    producto_codigo
                    formato_codigo
                    margen_ganacia_porcentaje
                    precio_neto
                    fecha_registro
                    precio_costo
                    precio_costo_penultimo
                    precio_costo_antepenultimo
                    fecha_modificacion
                    rut_usuario_creacion
                    rut_usuario_modificacion
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
          sucursal_codigo: this.sucursal_codigo,
          producto_codigo: producto,
          formato_codigo: formato
        },
        fetchPolicy: 'no-cache',
      }, function (respuesta) {
        self.formDatosComerciales.get('neto1').setValue("");
        self.formDatosComerciales.get('neto2').setValue("");
        self.formDatosComerciales.get('neto3').setValue("");
        self.formDatosComerciales.get('neto4').setValue("");
        self.formDatosComerciales.get('neto5').setValue("");
        self.iva1 = 0
        self.impAdicional1 = 0;
        self.preciofinal1 = 0;
        self.iva2 = 0
        self.impAdicional2 = 0;
        self.preciofinal2 = 0;
        self.iva3 = 0
        self.impAdicional3 = 0;
        self.preciofinal3 = 0;
        self.iva4 = 0
        self.impAdicional4 = 0;
        self.preciofinal4 = 0;
        self.iva5 = 0
        self.impAdicional5 = 0;
        self.preciofinal5 = 0;
        self.formDatosComerciales.get('margen1').setValue(0);
        self.formDatosComerciales.get('margen2').setValue(0);
        self.formDatosComerciales.get('margen3').setValue(0);
        self.formDatosComerciales.get('margen4').setValue(0);
        self.formDatosComerciales.get('margen5').setValue(0);
        self.neto_1 = 0;
        self.margen_1 = 0;
        self.neto_2 = 0;
        self.margen_2 = 0;
        self.neto_3 = 0;
        self.margen_3 = 0;
        self.neto_4 = 0;
        self.margen_4 = 0;
        self.neto_5 = 0;
        self.margen_5 = 0;
        const listaListaPrecioDetalle2 = respuesta.data.lista_precio_detalle.obtenerListaPrecio.respuesta.registros;
        if (listaListaPrecioDetalle2.length > 0) {
          listaListaPrecioDetalle2.forEach(element => {
            if (element.lista_precio_codigo === 1) {
              self.formDatosComerciales.get('neto1').setValue(element.precio_neto);
              //self.formDatosComerciales.get('margen1').setValue(element.margen_ganacia_porcentaje);
              self.neto_1 = element.precio_neto;
              self.margen_1 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo === 2) {
              self.formDatosComerciales.get('neto2').setValue(element.precio_neto);
              //self.formDatosComerciales.get('margen2').setValue(element.margen_ganacia_porcentaje);
              self.neto_2 = element.precio_neto;
              self.margen_2 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo === 3) {
              self.formDatosComerciales.get('neto3').setValue(element.precio_neto);
              //self.formDatosComerciales.get('margen3').setValue(element.margen_ganacia_porcentaje);
              self.neto_3 = element.precio_neto;
              self.margen_3 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo === 4) {
              self.formDatosComerciales.get('neto4').setValue(element.precio_neto);
              //self.formDatosComerciales.get('margen4').setValue(element.margen_ganacia_porcentaje);
              self.neto_4 = element.precio_neto;
              self.margen_4 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo === 5) {
              self.formDatosComerciales.get('neto5').setValue(element.precio_neto);
              //self.formDatosComerciales.get('margen5').setValue(element.margen_ganacia_porcentaje);
              self.neto_5 = element.precio_neto;
              self.margen_5 = element.margen_ganacia_porcentaje;
            }
          });
        }
      });
    }
  }

  public loadAndShow(producto: producto, parametro_iva: number) {
    this.disabledContent = false
    // this.producto = producto
    this.parametro_iva = parametro_iva

    this.formDatosComerciales.reset();
    this.iva1 = 0
    this.impAdicional1 = 0;
    this.preciofinal1 = 0;
    this.iva2 = 0
    this.impAdicional2 = 0;
    this.preciofinal2 = 0;
    this.iva3 = 0
    this.impAdicional3 = 0;
    this.preciofinal3 = 0;
    this.iva4 = 0
    this.impAdicional4 = 0;
    this.preciofinal4 = 0;
    this.iva5 = 0
    this.impAdicional5 = 0;
    this.preciofinal5 = 0;
    // this.listaListaPrecioDetalle = [];
    this.formDatosComerciales.get('producto_codigo').setValue(producto.codigo);
    this.formDatosComerciales.get('margen1').disable();
    this.formDatosComerciales.get('margen1').setValue(0);
    this.formDatosComerciales.get('margen2').disable();
    this.formDatosComerciales.get('margen2').setValue(0);
    this.formDatosComerciales.get('margen3').disable();
    this.formDatosComerciales.get('margen3').setValue(0);
    this.formDatosComerciales.get('margen4').disable();
    this.formDatosComerciales.get('margen4').setValue(0);
    this.formDatosComerciales.get('margen5').disable();
    this.formDatosComerciales.get('margen5').setValue(0);
    this.obtenerElementosProducto(producto.codigo);

    //this.log('inputParams', JSON.stringify(this.formDatosComerciales.get('formato').value))
    //this.loadPrecioCosto(producto.codigo, this.formDatosComerciales.get('formato').value)
  }

  obtenerElementosProducto(producto_codigo: number) {
    let self = this;
    this.client.query({
      query: gql`
      query($empresa_rut: Decimal, $producto_codigo:Decimal){

        producto_impuesto{
          obtenerSegunIdProducto(entidad:{empresa_rut:$empresa_rut,
            producto_codigo:$producto_codigo
          }){
            respuesta{
              empresa_rut
              producto_codigo
              impuesto_codigo
              fecha_registro
              factor
              valor
            }
          }
        }

        producto_formato{
          obtenerProductosFormatos(filtro:{
            exacto:{
              empresa_rut:$empresa_rut,
              producto_codigo:$producto_codigo,
            }
          }){
            respuesta{
              registros{
                empresa_rut
                producto_codigo
                formato_codigo
                formato_nombre
                peso_neto
                volumen
                fecha_registro
                cantidad
                activo
                formato_codigo_top
                formato_secundario
              }
            }
          }
        }
      }
      `,
      variables: {
        "empresa_rut": this.rut_empresa,
        "producto_codigo": producto_codigo
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      // let codigo_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.codigo;
      // let nombre_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.nombre;
      // setTimeout(() => self.formulario.controls["familia_codigo"].setValue(codigo_familia), 300);
      // setTimeout(() => self.formResumen.controls["familia"].setValue(nombre_familia), 300);

      // let codigo_unidad_medida = respuesta.data.unidad_medida.obtenerUnidad_MedidaProducto.respuesta.codigo;
      // if (codigo_unidad_medida != 0) {
      //   self.formulario.controls["unidad_medida_codigo"].setValue(codigo_unidad_medida);
      // } else {
      //   self.formulario.controls["unidad_medida_codigo"].setValue('');
      // }

      const seleccionProductoImpuestoJoin = respuesta.data.producto_impuesto.obtenerSegunIdProducto.respuesta;
      if (seleccionProductoImpuestoJoin != null) {
        //   self.codigo_impuesto = self.seleccionProductoImpuestoJoin.impuesto_codigo;
        self.impuestoAdicPro = seleccionProductoImpuestoJoin.valor;
      }
      //  else {
      //   self.codigo_impuesto = 0;
      // }

      const listaProductoFormatoEditar = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
      // self.listaProductoFormatoResumen = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
      self.optionsFormatoProducto = [];
      var sel: any;
      listaProductoFormatoEditar.forEach(element => {
        if (element.activo == true) {
          sel = { value: element.formato_codigo, label: element.formato_nombre };
          self.optionsFormatoProducto.push(sel);
        }
      });

      self.showModalModificarDtoComeciales()
      self.setDefaultFormat(listaProductoFormatoEditar, producto_codigo)
    });
  }

  setDefaultFormat(listaProductoFormatoEditar, producto_codigo) {
    // Default format
    const _lstFormatoCodigoTop = listaProductoFormatoEditar.filter(f => f.formato_codigo_top === f.formato_codigo)
    if (_lstFormatoCodigoTop.length > 0) {
      this.formDatosComerciales.get('formato').setValue(_lstFormatoCodigoTop[0].formato_codigo)
      this.loadPrecioCosto(producto_codigo, this.formDatosComerciales.get('formato').value)
    }
    else if (listaProductoFormatoEditar.length > 0)
      this.formDatosComerciales.get('formato').setValue(listaProductoFormatoEditar[0].formato_codigo)
  }

  showModalModificarDtoComeciales() {
    const self = this;
    let codigo_operacion = 14
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // self.editarModalDtoComerciales.show();
        // self.editarComercialesModal.show()
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  actualizarDatosComerciales() {
    if (this.formDatosComerciales.controls["neto1"].value != "" && this.formDatosComerciales.controls["neto1"].value != null) {
      var arrLista1 = {
        lista_precio_codigo: 1,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: this.formDatosComerciales.controls["producto_codigo"].value,
        formato_codigo: this.formDatosComerciales.controls["formato"].value,
        margen_ganacia_porcentaje: Math.round(this.formDatosComerciales.controls["margen1"].value).toFixed(2),
        precio_neto: this.formDatosComerciales.controls["neto1"].value,
        fecha_registro: new Date(),
        precio_costo: 0,
        precio_costo_penultimo: 0,
        precio_costo_antepenultimo: 0,
        fecha_modificacion: new Date(),
        rut_usuario_creacion: this.rut_usuario,
        rut_usuario_modificacion: this.rut_usuario
      };
      this.listaListaPrecioDetalle.push(arrLista1)
    }
    if (this.formDatosComerciales.controls["neto2"].value != "" && this.formDatosComerciales.controls["neto2"].value != null) {
      var arrLista2 = {
        lista_precio_codigo: 2,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: this.formDatosComerciales.controls["producto_codigo"].value,
        formato_codigo: this.formDatosComerciales.controls["formato"].value,
        margen_ganacia_porcentaje: Math.round(this.formDatosComerciales.controls["margen2"].value).toFixed(2),
        precio_neto: this.formDatosComerciales.controls["neto2"].value,
        fecha_registro: new Date(),
        precio_costo: 0,
        precio_costo_penultimo: 0,
        precio_costo_antepenultimo: 0,
        fecha_modificacion: new Date(),
        rut_usuario_creacion: this.rut_usuario,
        rut_usuario_modificacion: this.rut_usuario
      };
      this.listaListaPrecioDetalle.push(arrLista2)
    }

    if (this.formDatosComerciales.controls["neto3"].value != "" && this.formDatosComerciales.controls["neto3"].value != null) {
      var arrLista3 = {
        lista_precio_codigo: 3,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: this.formDatosComerciales.controls["producto_codigo"].value,
        formato_codigo: this.formDatosComerciales.controls["formato"].value,
        margen_ganacia_porcentaje: Math.round(this.formDatosComerciales.controls["margen3"].value).toFixed(),
        precio_neto: this.formDatosComerciales.controls["neto3"].value,
        fecha_registro: new Date(),
        precio_costo: 0,
        precio_costo_penultimo: 0,
        precio_costo_antepenultimo: 0,
        fecha_modificacion: new Date(),
        rut_usuario_creacion: this.rut_usuario,
        rut_usuario_modificacion: this.rut_usuario
      };
      this.listaListaPrecioDetalle.push(arrLista3)
    }

    if (this.formDatosComerciales.controls["neto4"].value != "" && this.formDatosComerciales.controls["neto4"].value != null) {
      var arrLista4 = {
        lista_precio_codigo: 4,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: this.formDatosComerciales.controls["producto_codigo"].value,
        formato_codigo: this.formDatosComerciales.controls["formato"].value,
        margen_ganacia_porcentaje: Math.round(this.formDatosComerciales.controls["margen4"].value).toFixed(2),
        precio_neto: this.formDatosComerciales.controls["neto4"].value,
        fecha_registro: new Date(),
        precio_costo: 0,
        precio_costo_penultimo: 0,
        precio_costo_antepenultimo: 0,
        fecha_modificacion: new Date(),
        rut_usuario_creacion: this.rut_usuario,
        rut_usuario_modificacion: this.rut_usuario
      };
      this.listaListaPrecioDetalle.push(arrLista4)
    }

    if (this.formDatosComerciales.controls["neto5"].value != "" && this.formDatosComerciales.controls["neto5"].value != null) {
      var arrLista5 = {
        lista_precio_codigo: 5,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: this.formDatosComerciales.controls["producto_codigo"].value,
        formato_codigo: this.formDatosComerciales.controls["formato"].value,
        margen_ganacia_porcentaje: Math.round(this.formDatosComerciales.controls["margen5"].value).toFixed(2),
        precio_neto: this.formDatosComerciales.controls["neto5"].value,
        fecha_registro: new Date(),
        precio_costo: 0,
        precio_costo_penultimo: 0,
        precio_costo_antepenultimo: 0,
        fecha_modificacion: new Date(),
        rut_usuario_creacion: this.rut_usuario,
        rut_usuario_modificacion: this.rut_usuario
      };
      this.listaListaPrecioDetalle.push(arrLista5)
    }
    this.log('listaListaPrecioDetalle', this.listaListaPrecioDetalle);
    this.postDatosComerciales(this.listaListaPrecioDetalle);
  }

  postDatosComerciales(listaPrecio: lista_precio_detalle[]) {
    for (var i = 0; i < listaPrecio.length; i++) {
      delete listaPrecio[i]["__typename"];
    }
    let self = this;
    var bodyx = listaPrecio;
    this.log('inputParams', JSON.stringify(listaPrecio))
    this.client.mutate({
      mutation: gql`
      mutation($entidad:lista_precio_detalleListaInputType){
        lista_precio_detalle{
          guardaListaPrecio(entidad:$entidad){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet": bodyx
        }
      }
    },
      function (mensajes) {
        if (mensajes.data.lista_precio_detalle.guardaListaPrecio.mensajes != undefined) {
          //self.formDatosComerciales.reset();
          self.iva1 = 0
          self.impAdicional1 = 0;
          self.preciofinal1 = 0;
          self.iva2 = 0
          self.impAdicional2 = 0;
          self.preciofinal2 = 0;
          self.iva3 = 0
          self.impAdicional3 = 0;
          self.preciofinal3 = 0;
          self.iva4 = 0
          self.impAdicional4 = 0;
          self.preciofinal4 = 0;
          self.iva5 = 0
          self.impAdicional5 = 0;
          self.preciofinal5 = 0;
          self.listaListaPrecioDetalle = [];
          self.formDatosComerciales.get('neto1').setValue("");
          self.formDatosComerciales.get('neto2').setValue("");
          self.formDatosComerciales.get('neto3').setValue("");
          self.formDatosComerciales.get('neto4').setValue("");
          self.formDatosComerciales.get('neto5').setValue("");
          self.formDatosComerciales.get('neto5').setValue("");
          self.formDatosComerciales.get('margen1').setValue("");
          self.formDatosComerciales.get('margen2').setValue("");
          self.formDatosComerciales.get('margen3').setValue("");
          self.formDatosComerciales.get('margen4').setValue("");
          self.formDatosComerciales.get('margen5').setValue("");
          self.formDatosComerciales.get('formato').setValue("");
          self.showSuccess();
          self.onSuccess.emit()
        }
      });
  }

  showSuccess() {
    const options = { opacity: 1 };
    this.toastrService.success('Registro grabado!', 'Información!', options);
  }

  public validate() {
    return this.formValidatorsService.validate(this.formDatosComerciales)
  }

  public enable() {
    this.disabledContent = false
  }

  public disable() {
    this.disabledContent = true
  }

  showEditarPrecioCosto() {
    // this.formulario.get('formato').setValue(productoFormato.formato_codigo);
    this.modalSeleccionarPrecioCosto.loadAndShow(this.formDatosComerciales.controls["producto_codigo"].value, this.formDatosComerciales.controls["formato"].value, this.precio_costo)
  }

  onPrecioCostoSeleccionado(newValues: any) {
    this.precio_costo = newValues.precio
    this.reCalcularLista1()
    this.reCalcularLista2()
    this.reCalcularLista3()
    this.reCalcularLista4()
    this.reCalcularLista5()
  }

  loadPrecioCosto(producto: number, formato_codigo: string) {
    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        producto_codigo: producto,
        formato_codigo: formato_codigo
      }
    }
    this.listaPrecioDetalleService.obtenerPrecioCosto(inputParams, ({ respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.precio_costo = 0
        return
      }
      this.precio_costo = respuesta.precio_costo
      this.log('Precio Costo', this.precio_costo)
      //this.onPrecioCostoSeleccionado(this.precio_costo)
    })
  }
  reCalcularLista1() {
    if (this.formDatosComerciales.controls["neto1"].value !== null) {
      let margen1 = this.precio_costo === 0 ? 0 : (Math.abs((1 - (this.formDatosComerciales.get("neto1").value / this.precio_costo)) * 100)).toFixed(4);
      this.formDatosComerciales.get('margen1').setValue(margen1);
      this.iva1 = Number((this.formDatosComerciales.controls["neto1"].value * (this.parametro_iva / 100)).toFixed(2))
      if (this.iva1 != 0) {
        if (this.impuestoAdicPro != 0) {
          this.impAdicional1 = Number((this.formDatosComerciales.controls["neto1"].value * (this.impuestoAdicPro / 100)).toFixed(2));
        } else {
          this.impAdicional1 = 0;
        }
        this.preciofinal1 = (this.iva1 + this.impAdicional1 + this.formDatosComerciales.controls["neto1"].value).toFixed(2);
      } else {
        this.formDatosComerciales.get('margen1').setValue(0);
        this.iva1 = 0
        this.impAdicional1 = 0;
        this.preciofinal1 = 0;
      }
    } else {
      this.formDatosComerciales.get('margen1').setValue(0);
      this.iva1 = 0
      this.impAdicional1 = 0;
      this.preciofinal1 = 0;
    }
  }

  reCalcularLista2() {
    if (this.formDatosComerciales.controls["neto2"].value !== null) {
      let margen2 = this.precio_costo === 0 ? 0 : (Math.abs((1 - (this.formDatosComerciales.controls["neto2"].value / this.precio_costo)) * 100)).toFixed(4);
      this.formDatosComerciales.get('margen2').setValue(margen2);
      this.iva2 =  Number((this.formDatosComerciales.controls["neto2"].value * (this.parametro_iva / 100)).toFixed(2));
      if (this.iva2 != 0) {
        if (this.impuestoAdicPro != 0) {
          this.impAdicional2 = Number((this.formDatosComerciales.controls["neto2"].value * (this.impuestoAdicPro / 100)).toFixed(2));
        } else {
          this.impAdicional2 = 0;
        }
        this.preciofinal2 = (this.iva2 + this.impAdicional2 + this.formDatosComerciales.controls["neto2"].value).toFixed(2);
      } else {
        this.formDatosComerciales.get('margen2').setValue(0);
        this.iva2 = 0
        this.impAdicional2 = 0;
        this.preciofinal2 = 0;
      }
    } else {
      this.formDatosComerciales.get('margen2').setValue(0);
      this.iva2 = 0
      this.impAdicional2 = 0;
      this.preciofinal2 = 0;
    }
  }

  reCalcularLista3() {
    if (this.formDatosComerciales.controls["neto3"].value !== null) {
      let margen3 = this.precio_costo === 0 ? 0 : (Math.abs((1 - (this.formDatosComerciales.controls["neto3"].value / this.precio_costo)) * 100)).toFixed(4);
      this.formDatosComerciales.get('margen3').setValue(margen3);
      this.iva3 =  Number((this.formDatosComerciales.controls["neto3"].value * (this.parametro_iva / 100)).toFixed(2));
      if (this.iva3 != 0) {
        if (this.impuestoAdicPro != 0) {
          this.impAdicional3 =Number((this.formDatosComerciales.controls["neto3"].value * (this.impuestoAdicPro / 100)).toFixed(2));
        } else {
          this.impAdicional3 = 0;
        }
        this.preciofinal3 = (this.iva3 + this.impAdicional3 + this.formDatosComerciales.controls["neto3"].value).toFixed(2);
      } else {
        this.formDatosComerciales.get('margen3').setValue(0);
        this.iva3 = 0
        this.impAdicional3 = 0;
        this.preciofinal3 = 0;
      }
    } else {
      this.formDatosComerciales.get('margen3').setValue(0);
      this.iva3 = 0
      this.impAdicional3 = 0;
      this.preciofinal3 = 0;
    }
  }

  reCalcularLista4() {
    if (this.formDatosComerciales.controls["neto4"].value !== null) {
      let margen4 = this.precio_costo === 0 ? 0 : (Math.abs((1 - (this.formDatosComerciales.controls["neto4"].value / this.precio_costo)) * 100)).toFixed(4);
      this.formDatosComerciales.get('margen4').setValue(margen4);
      this.iva4 =  Number((this.formDatosComerciales.controls["neto4"].value * (this.parametro_iva / 100)).toFixed(2));
      if (this.iva4 != 0) {
        if (this.impuestoAdicPro != 0) {
          this.impAdicional4 = Number((this.formDatosComerciales.controls["neto4"].value * (this.impuestoAdicPro / 100)).toFixed(2));
        }
        else {
          this.impAdicional4 = 0;
        }
        this.preciofinal4 = (this.iva4 + this.impAdicional4 + this.formDatosComerciales.controls["neto4"].value).toFixed(2);
      } else {
        this.formDatosComerciales.get('margen4').setValue(0);
        this.iva4 = 0
        this.impAdicional4 = 0;
        this.preciofinal4 = 0;
      }
    } else {
      this.formDatosComerciales.get('margen4').setValue(0);
      this.iva4 = 0
      this.impAdicional4 = 0;
      this.preciofinal4 = 0;
    }
  }

  reCalcularLista5() {
    if (this.formDatosComerciales.controls["neto4"].value !== null) {
      let margen5 = this.precio_costo === 0 ? 0 : (Math.abs((1 - (this.formDatosComerciales.controls["neto5"].value / this.precio_costo)) * 100)).toFixed(4);
      this.formDatosComerciales.get('margen5').setValue(margen5);
      this.iva5 =  Number((this.formDatosComerciales.controls["neto5"].value * (this.parametro_iva / 100)).toFixed(2));
      if (this.iva5 != 0) {
        if (this.impuestoAdicPro != 0) {
          this.impAdicional5 = Number((this.formDatosComerciales.controls["neto5"].value * (this.impuestoAdicPro / 100)).toFixed(2));
        }
        else {
          this.impAdicional5 = 0;
        }
        this.preciofinal5 = (this.iva5 + this.impAdicional5 + this.formDatosComerciales.controls["neto5"].value).toFixed(2);
      } else {
        this.formDatosComerciales.get('margen5').setValue(0);
        this.iva5 = 0
        this.impAdicional5 = 0;
        this.preciofinal5 = 0;
      }
    } else {
      this.formDatosComerciales.get('margen5').setValue(0);
      this.iva5 = 0
      this.impAdicional5 = 0;
      this.preciofinal5 = 0;
    }
  }
}
